import back from 'assets/images/eventBoatRacingT10/back.png'

export default function ButtonBack({ handleNextPage }) {
	return (
		<div onClick={handleNextPage} className='button-back-event-10' >
			<img src={back} alt="img-button-back" className="button-back-event" />
		</div>
	)
}
